import { useEffect, useState } from 'react';

import { ORG_SET_EVENT } from 'constants/globalConstants';
import { storage } from 'services/config/storage';

/**
 * The assessment's configured login type (EMAIL / PHONE / THIRD_PARTY) is written to
 * local storage by the gameplay config fetch, which resolves *after* the sign-in screen
 * first renders. Reading it once during render therefore gives a stale (or missing) value
 * on a fresh visit and whenever the candidate comes back to the sign-in step from the OTP
 * step, which used to fall the screen back to the email form on a phone-only assessment.
 *
 * Keeping it in state and re-reading it whenever the config settles keeps the sign-in
 * screen on the delivery method the assessment is actually configured for.
 *
 * @param {...any} signals values that change once the gameplay config has been fetched
 */
export default function useLoginType(...signals) {
  const [loginType, setLoginType] = useState(() => storage.get.loginType());

  useEffect(() => {
    const sync = () => {
      const current = storage.get.loginType();
      setLoginType((prev) => (prev === current ? prev : current));
    };

    sync();
    window.addEventListener(ORG_SET_EVENT, sync);
    window.addEventListener('storage', sync);
    window.addEventListener('pageshow', sync);

    return () => {
      window.removeEventListener(ORG_SET_EVENT, sync);
      window.removeEventListener('storage', sync);
      window.removeEventListener('pageshow', sync);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, signals);

  return loginType;
}
